/**
 * Mirrors common/dependencies/auth/authorization.py
 */

export function matchAuthPattern(pattern: string, permission: string): boolean {
  const patternParts = pattern.split(".");
  const permissionParts = permission.split(".");

  let patternIdx = 0;
  let permissionIdx = 0;

  while (patternIdx < patternParts.length && permissionIdx < permissionParts.length) {
    const patternPart = patternParts[patternIdx];
    const permissionPart = permissionParts[permissionIdx];

    if (patternPart === "*") {
      if (patternIdx === patternParts.length - 1) {
        return true;
      }
      permissionIdx += 1;
      patternIdx += 1;
      continue;
    }

    if (permissionPart === "*") {
      if (permissionIdx === permissionParts.length - 1) {
        return true;
      }
      permissionIdx += 1;
      patternIdx += 1;
      continue;
    }

    if (patternPart !== permissionPart) {
      return false;
    }

    patternIdx += 1;
    permissionIdx += 1;
  }

  if (patternIdx === patternParts.length && permissionIdx === permissionParts.length) {
    return true;
  }

  if (patternIdx < patternParts.length && patternParts[patternParts.length - 1] === "*") {
    return true;
  }

  if (
    permissionIdx < permissionParts.length &&
    permissionParts[permissionParts.length - 1] === "*"
  ) {
    return true;
  }

  return false;
}

function isBroaderPermission(candidate: string, reference: string): boolean {
  if (!matchAuthPattern(reference, candidate)) {
    return false;
  }
  const candParts = candidate.split(".");
  const refParts = reference.split(".");
  if (candParts.length < refParts.length) {
    return true;
  }
  if (candidate.endsWith(".*") && !reference.endsWith(".*")) {
    return true;
  }
  return false;
}

export function hasPermission(
  userPermissions: readonly string[],
  requiredPermission: string,
): boolean {
  if (!userPermissions.length) {
    return false;
  }

  if (userPermissions.includes(requiredPermission)) {
    return true;
  }

  for (const userPerm of userPermissions) {
    if (matchAuthPattern(userPerm, requiredPermission)) {
      if (!isBroaderPermission(requiredPermission, userPerm)) {
        return true;
      }
    }
  }

  return false;
}
